var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoiceOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 29,
    viewBox: "0 0 19 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1147 14.9143C18.1147 14.3511 17.6841 13.9204 17.1209 13.9204C16.5577 13.9204 16.127 14.3511 16.127 14.9143C16.127 18.7903 12.9798 21.9375 9.10376 21.9375C5.22771 21.9375 2.08049 18.7903 2.08049 14.9143C2.08049 14.3511 1.64982 13.9204 1.08663 13.9204C0.523445 13.9204 0.0927734 14.3511 0.0927734 14.9143C0.0927734 19.5191 3.53815 23.3952 8.1099 23.8921V26.5424H4.49888C3.93569 26.5424 3.50502 26.9731 3.50502 27.5363C3.50502 28.0995 3.93569 28.5301 4.49888 28.5301H13.7086C14.2718 28.5301 14.7025 28.0995 14.7025 27.5363C14.7025 26.9731 14.2718 26.5424 13.7086 26.5424H10.0976V23.8921C14.6694 23.3952 18.1147 19.5191 18.1147 14.9143Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10377 0.370605C6.05594 0.370605 3.57129 2.85525 3.57129 5.90308V14.8809C3.57129 17.9619 6.05594 20.4134 9.10377 20.4465C12.1516 20.4465 14.6362 17.9619 14.6362 14.9141V5.90308C14.6362 2.85525 12.1516 0.370605 9.10377 0.370605Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceOrder);
export default __webpack_public_path__ + "static/media/voice_order.cf369767dc17e8f0b3f6f3ae95b43ade.svg";
export { ForwardRef as ReactComponent };